// src/pages/SellerIntelligence/index.js
import React from 'react';
import { FiTrendingUp, FiShoppingBag, FiTag, FiPackage, FiDollarSign } from 'react-icons/fi';
import styles from './SellerIntelligence.module.css';
import FeatureCardGrid from './components/FeatureCardGrid';

// Top of the Seller Intelligence section. Entries are grouped by domain, so a
// domain that will hold several dashboards opens its own index rather than
// listing every dashboard here.
const SECTIONS = [
  {
    id: 'sales',
    title: 'Sales',
    description: 'How the business is moving — revenue, units, growth, and the products and categories behind them.',
    icon: <FiTrendingUp />,
    route: '/dashboard/seller-intelligence/sales',
    action: 'Open →'
  },
  {
    id: 'orders',
    title: 'Orders',
    description: 'What your orders are made of, when they arrive, and how much customers buy at a time.',
    icon: <FiShoppingBag />,
    route: '/dashboard/seller-intelligence/orders',
    action: 'Open →'
  },
  {
    id: 'pricing',
    title: 'Pricing',
    description: 'What your prices, deals and promotions did to margin, and where the next budget should go.',
    icon: <FiTag />,
    route: '/dashboard/seller-intelligence/pricing',
    action: 'Open →'
  },
  {
    id: 'catalogue_health',
    title: 'Catalogue Health',
    description: 'Find and fix listing issues across your product catalogue.',
    icon: <FiPackage />,
    route: '/dashboard/seller-intelligence/catalogue-health',
    action: 'Open →'
  },
  {
    id: 'profit_margin',
    title: 'Profit & Margin',
    description: 'What Amazon charged, what you kept, and which products are losing money.',
    icon: <FiDollarSign />,
    route: '/dashboard/seller-intelligence/profit',
    action: 'Open →'
  }
];

const SellerIntelligence = () => (
  <div className={styles.featureContainer}>
    <div className={styles.header}>
      <div className={styles.titleSection}>
        <div className={styles.iconTitle}><h1>Seller Intelligence</h1></div>
        <p>Insights and analytics to grow your Amazon business</p>
      </div>
    </div>
    <div className={styles.content}>
      <FeatureCardGrid items={SECTIONS} />
    </div>
  </div>
);

export default SellerIntelligence;
